var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockMinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.83301C11.6827 1.83301 14.6673 4.81767 14.6673 8.49967C14.6673 12.1817 11.6827 15.1663 8.00065 15.1663C4.31865 15.1663 1.33398 12.1817 1.33398 8.49967C1.33398 4.81767 4.31865 1.83301 8.00065 1.83301ZM8.00065 3.16634C6.58616 3.16634 5.22961 3.72824 4.22941 4.72844C3.22922 5.72863 2.66732 7.08519 2.66732 8.49967C2.66732 9.91416 3.22922 11.2707 4.22941 12.2709C5.22961 13.2711 6.58616 13.833 8.00065 13.833C9.41514 13.833 10.7717 13.2711 11.7719 12.2709C12.7721 11.2707 13.334 9.91416 13.334 8.49967C13.334 7.08519 12.7721 5.72863 11.7719 4.72844C10.7717 3.72824 9.41514 3.16634 8.00065 3.16634ZM8.00065 4.49967C8.16394 4.4997 8.32154 4.55965 8.44357 4.66815C8.56559 4.77666 8.64355 4.92617 8.66265 5.08834L8.66732 5.16634V8.22367L10.472 10.0283C10.5915 10.1483 10.661 10.3093 10.6661 10.4786C10.6713 10.6479 10.6118 10.8128 10.4998 10.9399C10.3878 11.0669 10.2316 11.1465 10.063 11.1626C9.89439 11.1787 9.72598 11.1299 9.59198 11.0263L9.52932 10.971L7.52932 8.97101C7.4257 8.86731 7.35916 8.73234 7.33998 8.58701L7.33398 8.49967V5.16634C7.33398 4.98953 7.40422 4.81996 7.52925 4.69494C7.65427 4.56991 7.82384 4.49967 8.00065 4.49967Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockMinIcon);
export default __webpack_public_path__ + "static/media/clock-min-icon.9c7e8de04ca4761347389bcf0fe31024.svg";
export { ForwardRef as ReactComponent };